import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FormPage.css';

const FormPage = () => {
  const navigate = useNavigate();

  const handleSeeOtherEvents = () => {
    navigate('/');
  };

  return (
    <div className="form-page">
      <h2 className="form-title">Registration is Closed</h2>
      <button className="form-button" onClick={handleSeeOtherEvents}>
        See other events
      </button>
    </div>
  );
};

export default FormPage;

